
import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../components/ui/table";
import { ShareHoldingMoreThenFivePercentData } from "../../../types/CustomerInterface";
import { Fragment } from "react"
interface gstSessionProps {
  shareholders?: ShareHoldingMoreThenFivePercentData[],
  last_updated_date?:string;
}

export const ShareholdingSection: React.FC<gstSessionProps> = ({ shareholders,last_updated_date }) => {
  return (
    <section className="mb-6">
  <div className="flex items-center gap-3 mb-6">
    <h3 className="text-xl font-bold text-[#9e7926]">Shareholding More Than 5%</h3>
   
    {shareholders?.length === 0 ||
  !shareholders?.some(
    (yearData) =>
      yearData.company?.length ||
      yearData.llp?.length ||
      yearData.individual?.length ||
      yearData.others?.length
  )? ( <></>) : <p>As on. {last_updated_date}</p>}
  </div>

  {shareholders?.length === 0 ||
  !shareholders?.some(
    (yearData) =>
      yearData.company?.length ||
      yearData.llp?.length ||
      yearData.individual?.length ||
      yearData.others?.length
  ) ? (
    <div className="p-6 text-center text-gray-500 border rounded-lg bg-white shadow-sm">
      No shareholding above 5% found for this company.
    </div>
  ) : (
    <div className="bg-white rounded-lg border shadow-sm overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow className="bg-gray-50">
            <TableHead className="font-semibold text-gray-900">Shareholder Name</TableHead>
            <TableHead className="font-semibold text-gray-900">Type</TableHead>
            <TableHead className="text-right font-semibold text-gray-900">Shareholding %</TableHead>
            <TableHead className="text-right font-semibold text-gray-900">No. of Shares</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {shareholders.map((yearData, yearIndex) => (
            <Fragment key={`year-${yearIndex}`}>
              <TableRow>
                <TableCell colSpan={4} className="font-semibold bg-gray-100">
                  Financial Year: {yearData.financial_year}
                </TableCell>
              </TableRow>

              {yearData.company?.map((shareholder, index) => (
                <TableRow key={`year-${yearIndex}-company-${index}`}>
                  <TableCell className="font-medium">{shareholder.name}</TableCell>
                  <TableCell>Company</TableCell>
                  <TableCell className="text-right">{shareholder.shareholding_percentage}%</TableCell>
                  <TableCell className="text-right">{shareholder.no_of_shares?.toLocaleString()}</TableCell>
                </TableRow>
              ))}

              {yearData.llp?.map((shareholder, index) => (
                <TableRow key={`year-${yearIndex}-llp-${index}`}>
                  <TableCell className="font-medium">{shareholder.name}</TableCell>
                  <TableCell>LLP</TableCell>
                  <TableCell className="text-right">{shareholder.shareholding_percentage}%</TableCell>
                  <TableCell className="text-right">{shareholder.no_of_shares?.toLocaleString()}</TableCell>
                </TableRow>
              ))}

              {yearData.individual?.map((shareholder, index) => (
                <TableRow key={`year-${yearIndex}-individual-${index}`}>
                  <TableCell className="font-medium">{shareholder.name}</TableCell>
                  <TableCell>Individual</TableCell>
                  <TableCell className="text-right">{shareholder.shareholding_percentage}%</TableCell>
                  <TableCell className="text-right">{shareholder.no_of_shares?.toLocaleString()}</TableCell>
                </TableRow>
              ))}

              {yearData.others?.map((shareholder, index) => (
                <TableRow key={`year-${yearIndex}-others-${index}`}>
                  <TableCell className="font-medium">{shareholder.name}</TableCell>
                  <TableCell>Others</TableCell>
                  <TableCell className="text-right">{shareholder.shareholding_percentage}%</TableCell>
                  <TableCell className="text-right">{shareholder.no_of_shares?.toLocaleString()}</TableCell>
                </TableRow>
              ))}
            </Fragment>
          ))}
        </TableBody>
      </Table>
    </div>
  )}
</section>

  );
};
